import ReferenceCard from './ReferenceCard';

export default ReferenceCard;
